<!--
  画面名：体制データ入力画面
  概要： 食品安全チームに加わる従業員を従業員データに予め登録されている従業員から選択し、役割を決めた上で、チームメンバーとして登録する
  備考： 体制データにはFSM-G要求事項（FSM-G2）で求められる【簡潔に文書にした食品安全の方針】を合わせて入力できるようにする。
-->

<!-- HTML -->
<template>
  <v-form ref="form" lazy-validation>
    <!-- 体制データ入力のセクション -->
    <section class="organization" :class="{ list: isList }">
      <!-- ページ内コンテンツ -->
      <!-- 食品安全の方針 -->
      <div v-show="!isList" class="policy">
        <v-textarea
          v-show="!isRefer"
          v-model="inputPolicy"
          :placeholder="$language.MsgOrganizationPolicy"
          :disabled="isRefer"
          :class="{ reference: isRefer }"
          class="inputPolicy"
          name="input-7-4"
          box
          auto-grow
          @change="changeFnc(inputPolicy)"
        />
        <div v-show="isRefer" class="fixedPolicy">
          <p>{{ inputPolicy }}</p>
        </div>
      </div>
      <!-- 体制データ入力エリア -->
      <div class="oCart">
        <table>
          <tbody>
            <tr
              v-for="element in organization"
              :key="element.id"
              :class="element.level"
              style="display: block; float: left;"
            >
              <td
                v-for="(position, index) in element.positions"
                :key="position.id"
                class="mb-5"
                :style="[element.css.tdStyle, position.overrideStyle]"
              >
                <p v-if="position.subRole" :style="element.css.subRole">
                  {{ position.subRole }}
                </p>
                <!-- 体制図に使用されるボーダーを設定 -->
                <div
                  v-if="position.lineLeft"
                  :style="element.css.lineLeft"
                ></div>
                <div
                  v-if="position.lineRight"
                  :style="element.css.lineRight"
                ></div>
                <div
                  v-if="position.lineLeftTop"
                  :style="element.css.lineLeftTop"
                ></div>
                <div
                  v-if="position.lineLeftBottom"
                  :style="element.css.lineLeftBottom"
                ></div>
                <!-- 役職名を表示 -->
                <span :style="element.css.frame">{{ position.name }}</span>
                <div
                  v-if="position.selectStaff"
                  class="pa-2 inputStaff"
                  :class="{ inputStaffRefer: isRefer }"
                  :style="element.css.selectStyle"
                >
                  <!-- 従業員データをセレクトボックスで表示 -->
                  <v-combobox
                    v-model="selection[index - 1]"
                    :class="{ reference: isRefer }"
                    :items="employee"
                    :placeholder="$language.LabelEmployee"
                    :disabled="isRefer"
                    class="staffName"
                    height="40"
                    style="font-size:14px;"
                    hide-details
                    @change="changeFnc(selection[index - 1])"
                  />
                  <v-layout style="padding-top:15px;">
                    <v-flex class="xs7">
                      <!-- 部署名 -->
                      <v-text-field
                        v-model="post[index - 1]"
                        :placeholder="$language.LabelDepartment"
                        :disabled="isRefer"
                        style="font-size:14px;"
                        class="staffPost"
                        @change="changeFnc(post[index - 1])"
                      />
                    </v-flex>
                    <v-flex style="position: absolute;right: 8px;width: 160px;">
                      <!-- 連絡先 -->
                      <v-text-field
                        v-model="contact[index - 1]"
                        :placeholder="$language.LabelContact"
                        :rules="[telValidate(contact[index - 1])]"
                        :disabled="isRefer"
                        class="staffTel"
                        style="font-size:14px;"
                        @change="changeFnc(contact[index - 1])"
                      />
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </v-form>
</template>
<!-- /HTML -->

<script>
export default {
  name: 'Organization',
  props: {
    planId: Number,
    title: String,
    isNew: Boolean,
    isRefer: Boolean,
    isCopy: Boolean,
    policy: String,
    planCreateDate: String,
    organizationJson: String,
    organizationUserData: String,
    isList: Boolean,
  },
  // コンポーネント内の変数を定義
  data() {
    return {
      inputPolicy: '',
      // 従業員データ
      employee: [],
      // 体制図
      organization: [],
      // 担当者選択
      selection: ['', '', '', ''],
      // 部署名
      post: ['', '', '', ''],
      // 連絡先
      contact: ['', '', '', ''],
      // DBアクセスのカウントを保持
      accessCount: 0,
    }
  },
  // 画面表示時に実行する関数を設定
  created() {
    this.setPolicy()
    // DBから組織体制のjsonを取得
    this.setOrganization()
    // 従業員一覧を取得
    this.setEmployeeData()
    // 選択済の担当者を設定
    this.setStaffData()
  },
  // 関数群
  methods: {
    // DBのアクセス終了か判定
    loadComplete() {
      const maxCount = 2
      this.accessCount++
      if (maxCount === this.accessCount) {
        if (!this.$props.isList) {
          // プログレスバーの非表示
          this.$store.dispatch('setIsLoading', false)
        }
      }
    },
    // 食品安全の方針
    setPolicy() {
      this.inputPolicy = this.policy
    },
    // DBから組織体制のjsonを取得
    setOrganization() {
      const self = this
      function callbackSetOrganization(response) {
        // データベースから取得した体制図jsonを格納
        self.organization = response
        self.$forceUpdate()
        self.loadComplete()
      }
      if (this.organizationJson) {
        // 参照/編集/過去の計画書からコピーして作成の場合
        this.organization = JSON.parse(this.organizationJson)
      } else {
        const data = {}
        data.callback = callbackSetOrganization
        // 新規作成の場合
        this.$store.dispatch('systemConfig/actionSelectOrganization', data)
      }
    },
    // DBから従業員一覧を取得
    setEmployeeData() {
      const self = this
      function callbackSetEmployeeData(response) {
        // データベースから取得した従業員一覧をemployeeに格納する
        self.employee = response
        self.$forceUpdate()
        self.loadComplete()
      }
      const data = {}

      data.callback = callbackSetEmployeeData
      // 従業員一覧の取得
      this.$store.dispatch(
        'managementFunction/actionSelectEmployeeDataInOrganization',
        data
      )
    },
    // 選択済の担当者を設定
    setStaffData() {
      // 編集/参照の場合、親コンポーネントから取得したデータを格納する
      if (this.organizationUserData) {
        const staffData = JSON.parse(this.organizationUserData)
        this.selection = staffData.name
        this.post = staffData.post
        this.contact = staffData.contact
      }
    },
    // DBにデータを送る処理
    sendDB(AisTitle, isCopy, oldId) {
      const self = this
      // 親コンポーネントに計画書のIDを送る
      function callbackSendId(response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$emit('sendId', response.data[0].id, true)
      }
      // 親コンポーネントから保存完了ダイアログを表示
      function callbackOpenSaveDialog() {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$emit('openSaveDialog', null, true)
      }

      // 入力に誤りがある場合は確認ダイアログを表示する
      if (!this.$refs.form.validate()) {
        this.$emit('openConfirmDialog', true)
        return
      }
      if (AisTitle) {
        // 担当者データを配列に格納
        const userData = {}
        userData.name = this.selection
        userData.post = this.post
        userData.contact = this.contact
        const date = new Date()
        const dateNow = `${date.getFullYear()}/${`0${date.getMonth() +
          1}`.slice(-2)}/${`0${date.getDate()}`.slice(-2)}`

        const sendData = {
          title: this.title,
          organization: JSON.stringify(this.organization),
          organizationStaffData: userData,
          policy: this.inputPolicy,
          status: 10,
        }
        if (this.isNew) {
          sendData.createDate = dateNow
          sendData.isCopy = isCopy
          sendData.oldId = oldId
          sendData.callback = callbackSendId
          if (isCopy) {
            sendData.replaceName = this.$parent.replacePlanDocName
            sendData.addedName = this.$parent.addedPlanDocName
          }
          // 新規追加処理
          this.$store.dispatch(
            'managementFunction/actionInsertPlanOrganize',
            sendData
          )
        } else {
          sendData.id = this.planId
          sendData.callback = callbackOpenSaveDialog
          // 編集処理
          this.$store.dispatch(
            'managementFunction/actionUpdatePlanOrganize',
            sendData
          )
        }
      }
    },
    // 連絡先のバリデーションを設定する
    telValidate(value) {
      if (value && !value.match(/^0\d{2,3}-?\d{1,4}-?\d{4}$/)) {
        return this.$language.MsgFailedTel
      }
      return true
    },
    // 体制図の値が変更されたら呼ばれる
    changeFnc(value) {
      this.$emit('setCompleteOrganizationFalse')
    },
  },
}
</script>

<!-- style読み込み -->
<style lang="scss">
@import '@/assets/scss/managementFunction/setting.scss';
</style>
